import { useCallback } from 'react';

import { FilterCondition, useEngine } from '../aiem/engine/hooks';
import AIEnginesPage from '../components/AIEnginesPage/AIEnginesPage';

export default function MyAIEnginesPage() {
  const { searchEngines } = useEngine();

  const fetchEngines = useCallback(
    async (filter?: FilterCondition[]) => {
      return await searchEngines(filter || []);
    },
    [searchEngines]
  );

  return <AIEnginesPage title="Workspace AI Engines" fetchEngines={fetchEngines} admin={false} />;
}
